export interface IndexInfo {
    banner: BannerInfo[];
    message: IntroductionInfo[];
    // zh-tw only
    promotion: IntroductionInfo[];
    // zh-tw only
    sku: SkuInfo[];
}

export interface BannerInfo {
    imgSrc: string;
    imgName: string;
    imgUrl: string;
}

export interface IntroductionInfo {
    Id: number;
    title: string;
    fileName: string;
    introduction: string;
}

export interface SkuInfo {
    ExhibitsId: number;
    ExhibitsName: string;
    ThumbnailImg: string;
    URLink: string;
    UpdatedTime: string;
}

export interface ExhibitInfo {
    ExhibitsId: number;
    ExhibitsName: string;
    ThumbnailImg: string;
}

export interface ExhibitDetail {
    ExhibitsId: number;
    ExhibitsName: string;
    Dollar: string;
    Area: string;
    IssueTime: string;
    PlateYear: string;
    size_L: string;
    size_W: string;
    size_H: string;
    Obj_Type: string;
    Obj_color1: string;
    Obj_color2: string;
    Weight: string;
    Diameter: string;
    Exhibits_Content: string;
    imgDescr1: string;
    imgDescr2: string;
    imgDescr3: string;
    SurroundSwf: string;
    WebImg: string;
    ExtContent: string;
    obj_material: string;
    ExhibitsVers: string;
    ebook: string;
    ExhibitsType: number;
    img: ExhibitDetailImg[];
    FakeWeb: string;
}

export interface ExhibitDetailImg {
    imgType: string;
    imgSrc: string;
    imgName: string;
}

export interface HistoryExhibitInfo extends ExhibitInfo {
    PlateYear: string;
    WebImg: string;
}

export interface News {
    Id: number;
    publishStartDate: string;
    title: string;
    fileName: string;
    fileUrl: string;
    Color: string;
    url: string;
    introduction: string;
    NewsType: string;

    // expand
    ColorName: string;
}

export interface NewsDetail {
    Id: number;
    publishStartDate: string;
    title: string;
    content: string;
    fileName: string;
    fileUrl: string;
    Color: string;
    url: string;
    introduction: string;
    NewsType: string;

    // expand
    ColorName: string;
}

export interface Law {
    ID: number;
    LawName: string;
    LawHis: string;
    file1: string;
    file2: string;
    Detail: LawContent;
}

export interface LawContent {
    Content: string;
}

export interface Book {
    bookname: string;
    content: string;
    user1: string;
    user2: string;
    org: string;
    publishdate: string;
    language: string;
    ISBN: string;
    File1: string;
    File2: string;
    File3: string
}

export interface LinkInfo {
    Title: string;
    Area: string;
    ImgSrc: string;
    Url: string;
    language: string;
}

export interface Multimedia {
    ID: Number;
    Title: string;
    content: string;
    File1: string;
    File2: string;
    File3: string;
    File4: string;
    File5: string;
}

export interface Faq {
    question: string;
    answer: string;
    faq_type: string;
}

export interface Feedback {
    SendName: string;
    Sendtitle: string;
    Replycontent: string;
    Status: number;
    CreatedTime: string;
}

export const MultimediaType = {
    // 桌布參數：1
    desktop: 1,
    // 遊戲參數：6
    game: 3,
    // 學習單參數：5
    learn: 5,
    // 影片參數：6
    video: 6
};

export const MultimediaPageStasticsType = {
    // 1 = "桌布 800x600"
    desktop800_600: 1,
    // 2 = "桌布 1024x768"
    desktop1024_768: 2,
    // 3 = "桌布 1280x1024"
    desktop1280_1024: 3,
    // 4 = "桌布 1440x900"
    desktop1440_900: 4,
    // 5 = "桌布 1920x1200"
    desktop1920_1200: 5,
    // 7 = "遊戲"
    game: 7,
    // 8 = "兒童版電子書"
    learn: 8,
    // 9 = "影片"
    video: 9
};

export const LinkArea = {
    taiwan: '臺灣',
    asia: '亞洲',
    america: '美洲',
    europe: '歐洲',
    africa: '非洲',
    oceania: '大洋洲'
};

export const NewsType = {
    // 訊息公告
    message: 'MESSAGE',
    // PROMOTION=>推廣專區
    promotion: 'PROMOTION'
};

export const NewsColorType = {
    // 1->國內券幣
    public: '1',
    // 2->券幣大小事
    propaganda: '2',
    // 3->紀念性券幣銷售
    activity: '3',
    // 4->防偽辨識
    education: '4',
    // 12->國外券幣
    downtime: '12',
    // 13->其他
    other: '13',
    // 14->其他資訊
    otherinformation: '14',
    // 15->金融文物館
    financial: '15',
};

export const CirculationType = {
    // 流通鈔券
    banknote: 52,
    // 紀念性流通鈔券
    anniversary: 53,
    // 鈔券圖話
    pictureGuide: 79,
    // 流通幣
    currency: 54,
    // 紀念性流通幣
    anniversaryCurrency: 55
};

export const CommemorateType = {
    // 第一輪
    zodiacSignFirst: 56,
    // 第二輪
    zodiacSignSecond: 57,
    // 第三輪
    zodiacSignThird: 80,

    // 臺灣國家公園采風系列
    themeNationalPark: 58,
    // 臺灣原住民文化采風系列
    themeAboriginal: 59,
    // 花卉蝴蝶系列
    themeFlower: 60,
    // 其它
    themeOther: 78,

    // 國家重要慶典
    coinNationalCelebration: 63,
    // 重要節日
    coinFestival: 64,
    // 著名國際性活動
    coinInternationalEvents: 65,
    // 特殊紀念事蹟
    coinSpecialMemorial: 67,

    // 紀念鈔券
    note: 66,

    // 國家重要慶典
    medalNationalCelebration: 61,
    // 重要節日
    medalFestival: 62
};

export const HistoryType = {
    // 關金券
    customs: 38,
    // 法幣
    legal: 39,
    // 金圓券
    gold: 40,
    // 銀元券
    silver: 41,
    // 銀本位幣
    standard: 42,
    // 其他鈔券
    other: 43,
    // 輔幣
    support: 71,

    // 明治時期
    meiji: 44,
    // 大正時期
    taisho: 45,
    // 昭和時期
    showa: 46,

    // 臺幣時期
    td: 47,

    // 臺灣銀行發行
    boc: 50,
    // 中央銀行發行
    centralBank: 51
};

export const ExhibitStasticsType = {
    circulation: '套幣與紀念性券幣'
}
